// Genre and Sub-genre mapping
export const genreSubgenreMap = {
  "Film": [
    "Devotional",
    "Dialogue",
    "Ghazal",
    "Hip-Hop/ Rap",
    "Instrumental",
    "Patriotic",
    "Remix",
    "Romantic",
    "Sad",
    "Unplugged"
  ],
  "Pop": [
    "Acoustic Pop",
    "Band Songs",
    "Bedroom Pop",
    "Chill Pop",
    "Contemporary Pop",
    "Country Pop/ Regional Pop",
    "Dance Pop",
    "Electro Pop",
    "Lo-Fi Pop",
    "Love Songs",
    "Pop Rap",
    "Pop Singer-Songwriter",
    "Sad Songs",
    "Soft Pop"
  ],
  "Indie": [
    "Indian Indie",
    "Indie Dance",
    "Indie Folk",
    "Indie Hip-Hop",
    "Indie Lo-Fi",
    "Indie Pop",
    "Indie Rock",
    "Indie Singer -Songwriter"
  ],
  "Hip-Hop/Rap": [
    "Alternative Hip-Hop",
    "Concious Hip-Hop",
    "Country Rap",
    "Emo Rap",
    "Hip-Hop",
    "Jazz Rap",
    "Pop Rap",
    "Trap",
    "Trap Beats"
  ],
  "Folk": [
    "Ainchaliyan",
    "Alha",
    "Atulprasadi",
    "Baalgeet/ Children Song",
    "Banvarh",
    "Barhamasa",
    "Basant Geet",
    "Baul Geet",
    "Bhadu Gaan",
    "Bhagawati",
    "Bhand",
    "Bhangra",
    "Bhatiali",
    "Bhavageete",
    "Bhawaiya",
    "Bhuta song",
    "Bihugeet",
    "Birha",
    "Borgeet",
    "Burrakatha",
    "Chappeli",
    "Daff",
    "Dandiya Raas",
    "Dasakathia",
    "Deijendrageeti",
    "Deknni",
    "Dhamal",
    "Gadhwali",
    "Gagor",
    "Garba",
    "Ghasiyari Geet",
    "Ghoomar",
    "Gidda",
    "Gugga",
    "Hafiz Nagma",
    "Heliam",
    "Hereileu",
    "Hori",
    "Jaanapada Geethe",
    "Jaita",
    "Jhoori",
    "Jhora",
    "Jhumur",
    "Jugni",
    "Kajari",
    "Kajari/ Kajari /Kajri",
    "Karwa Chauth Songs",
    "Khor",
    "Koligeet",
    "Kumayuni",
    "Kummi Paatu",
    "Lagna Geet /Marriage Song",
    "Lalongeeti",
    "Lavani",
    "Lokgeet",
    "Loor",
    "Maand",
    "Madiga Dappu",
    "Mando",
    "Mapilla",
    "Naatupura Paadalgal",
    "Naqual",
    "Nati",
    "Nautanki",
    "Nazrulgeeti",
    "Neuleu",
    "Nyioga",
    "Oggu Katha",
    "Paani Hari",
    "Pai Song",
    "Pandavani",
    "Pankhida",
    "Patua Sangeet",
    "Phag Dance",
    "Powada",
    "Qawwali",
    "Rabindra Sangeet",
    "Rajanikantageeti",
    "Ramprasadi",
    "Rasiya",
    "Rasiya Geet",
    "Raslila",
    "Raut Nacha",
    "Saikuthi Zai",
    "Sana Lamok",
    "Shakunakhar-Mangalgeet",
    "Shyama Sangeet",
    "Sohar",
    "Sumangali",
    "Surma",
    "Suvvi paatalu",
    "Tappa",
    "Teej songs",
    "Tusu Gaan",
    "Villu Pattu"
  ],
  "Devotional": [
    "Aarti",
    "Bhajan",
    "Carol",
    "Chalisa",
    "Chant",
    "Geet",
    "Gospel",
    "Gurbani",
    "Hymn",
    "Kirtan",
    "Mantra",
    "Paath",
    "Qawwals",
    "Shabd"
  ],
  "Hindustani Classical": [
    "Instrumental",
    "Vocal"
  ],
  "Carnatic Classical": [
    "Instrumental",
    "Vocal"
  ],
  "Ambient / Instrumental": [
    "Soft",
    "Easy Listening",
    "Electronic",
    "Fusion",
    "Lounge"
  ]
};

// Extract main genres list for backward compatibility
export const genreList = Object.keys(genreSubgenreMap);

// Function to get sub-genres for a given main genre
export const getSubGenres = (mainGenre) => {
  return genreSubgenreMap[mainGenre] || [];
};
